import { render, staticRenderFns } from "./edit-institution.vue?vue&type=template&id=41e12d0a&"
import script from "./edit-institution.vue?vue&type=script&lang=js&"
export * from "./edit-institution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports